function getAccessToken() {
    return localStorage.getItem('access_token')
}

function setAccessToken(token) {
    return localStorage.setItem('access_token', token)
}

function removeAccessToken() {
    return localStorage.removeItem('access_token')
}

function getAccountId() {
    return localStorage.getItem('account_id')
}

function setAccountId(id) {
    return localStorage.setItem('account_id', id)
}

function setAccountDomainId(id) {
    return localStorage.setItem('account_domain_id', id)
}

function getAccountDomainId() {
    return localStorage.getItem('account_domain_id')
}

function setAccountCloudflareId(id) {
    return localStorage.setItem('account_cloudflare_id', id)
}

function getAccountCloudflareId() {
    return localStorage.getItem('account_cloudflare_id')
}

function setAccountCloudFrontId(id) {
    return localStorage.setItem('account_cloudfront_id', id)
}

function getAccountCloudFrontId() {
    return localStorage.getItem('account_cloudfront_id')
}

function setAccountCloudServerId(id) {
    return localStorage.setItem('account_cloud_server_id', id)
}

function getAccountCloudServerId() {
    return localStorage.getItem('account_cloud_server_id')
}

function setAccountDomainCloudServerId(id) {
    return localStorage.setItem('account_domain_cloud_server_id', id)
}

function getAccountDomainCloudServerId() {
    return localStorage.getItem('account_domain_cloud_server_id')
}

export {
    getAccessToken,
    setAccessToken,
    removeAccessToken,
    getAccountId,
    setAccountId,
    setAccountDomainId,
    getAccountDomainId,
    setAccountCloudflareId,
    getAccountCloudflareId,
    setAccountCloudFrontId,
    getAccountCloudFrontId,
    setAccountCloudServerId,
    getAccountCloudServerId,
    setAccountDomainCloudServerId,
    getAccountDomainCloudServerId,
}
